module.exports = __webpack_public_path__ + "static/gallery_peak_6-66d36eda7bee78cf47c2820be430119d.jpg";